import React, { useState } from "react";
import { GraficChart } from "../../containers/GraficChart";
import { useAuth } from "../../contexts/AuthContext";
import { Request } from "../../hooks/Request";
import { H1 } from "../../components/Text";
import { H3 } from "../../components/Text";
import Texto from "../../components/Text/Texto";
import Label from "../../components/Text/Label";
import { useEffect } from "react";
import { BarChart } from '../../containers/BarChart'

const Summary = () => {
  const { user } = useAuth();

  return (
    <div className="bg-slate-200 h-full p-[10px] sm:p-[20px]">
      {user?.company?.length === 0 ? null : (
        <div className="bg-white m-[20px] p-[10px] sm:p-[20px] flex flex-col items-center">
          <div className="w-full bg-sky-900 rounded-xl py-4 px-4 mb-4">
             <h2 className="text-center text-xl font-bold text-white">
             {user?.company?.length === 1
                ? "INFORMACIÓN DE LA COMPAÑÍA"
                 : "INFORMACIÓN DE LAS COMPAÑÍAS"}
                </h2>
        </div>
          {user?.company?.map((company, index) => (
            <CompanySection key={index} company={company} />
          ))}
        </div>
      )}
      <div className="bg-white m-[20px] p-[10px] sm:p-[20px] flex flex-col items-center">

        <div className="w-full bg-sky-900 rounded-xl py-4 px-4 mb-6">
          <h2 className="text-center text-xl font-bold text-white">
                INFORMACIÓN DE USUARIO
          </h2>
            </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full">
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className="">NOMBRE</H3>
            <Texto className="">{user?.user?.name}</Texto>
          </div>
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className="">APELLIDO PATERNO</H3>
            <Texto className="">{user?.user?.fatherLastName}</Texto>
          </div>
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className=""> APELLIDO MATERNO</H3>
            <Texto className="">{user?.user?.motherLastName}</Texto>
          </div>
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className="">CARNET DE IDENTIDAD</H3>
            <Texto className="">{user?.user?.ci}</Texto>
          </div>
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className=""> Nro DE CELULAR </H3>
            <Texto className="">{user?.user?.cellphoneNumber}</Texto>
          </div>
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className=""> Nro DE TELEFONO </H3>
            <Texto className="">
              {user?.user?.phoneNumber
                ? user.user.phoneNumber
                : "No registrado"}
            </Texto>
          </div>
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 bg-sky-50 border border-sky-200 rounded-xl px-4 py-5">
            <H3 className=" "> EMAIL </H3>
            <Texto className=" ">{user?.user?.email}</Texto>
          </div>
        </div>
      </div>
    </div>
  );
};

const CompanySection = ({ company }) => {
  const [valueSelect, setvalueSelect] = useState(
  String(new Date().getFullYear())
  );


  return (
  <div className="flex w-full flex-col items-start gap-4 border-t border-slate-200 py-4">

    {/* Información de la empresa: 20% */}
    <InfoEmpresa user={company} />

    {/* Gráficas: 80% */}
    <div className="flex flex-wrap items-center justify-center gap-6 mb-6 w-full">

  <h3 className="text-xl font-bold text-sky-900">
    GRÁFICA CON EL TOTAL DE TRÁMITES
  </h3>

  <div className="flex items-center gap-2">
    <Label htmlFor="año">Filtrar por año</Label>

    <select
      id="año"
      value={valueSelect}
      onChange={(e) => setvalueSelect(e.target.value)}
      className="border border-gray-300 rounded px-2 py-1"
    >
      {Array.from(
        { length: new Date().getFullYear() - 2022 + 1 },
        (_, index) => {
          const year = 2022 + index;

          return (
            <option key={year} value={String(year)}>
             {year}
            </option>
          );
        }
      )}
    </select>
  </div>

</div>
        
       
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 w-full mt-4">

        {/* Gráfica circular */}
        <div className="w-full min-w-0 bg-white border border-slate-200 rounded-2xl shadow-md p-5">
        <div className="w-full mb-4">
         <h3 className="w-full text-center text-xl font-bold text-white bg-sky-900 rounded-lg py-3 px-4">
             Total de trámites
         </h3>
        </div>
          <div className="w-full max-w-[350px] mx-auto">
            <GraficChart year={valueSelect} values={company} />
          </div>
        </div>

        {/* Gráfica de barras */}
          <div className="w-full min-w-0 bg-white border border-slate-200 rounded-2xl shadow-md p-5">
          <h3 className="text-center text-xl font-bold text-white bg-sky-900 rounded-lg py-3 px-4 mb-4">
            Trámites por mes
          </h3>
          <div className="w-full">
             <BarChart year={valueSelect} />
          </div>
        </div>

      </div>
      </div>

  );
};

export default Summary;

const InfoEmpresa = ({ user }) => {
  const { data } = Request({
    urlApi: user.id ? `company/${user?.id}/ClientsCompany` : null,
  });

  function convertData(convertData) {
    let date = new Date(convertData);
    let fecha = "";
    if (
      date.getDate() !== 0 &&
      date.getMonth() !== 0 &&
      date.getFullYear() !== 0
    ) {
      return (fecha =
        date.getDate() + " / " + date.getMonth() + " / " + date.getFullYear());
    }
    return "No registrado";
  }

  return (
   <div className="flex flex-col items-center justify-center text-center w-full min-w-0 px-3 py-5">
      <H1>{user?.razonSocial}</H1>
      <div className="grid grid-cols-5 gap-3 w-full mt-4">
        {/* MODIFICACIÓN: utilizar todo el ancho disponible del contenedor de la empresa */}
          <div className="flex flex-col items-center justify-center text-center w-full min-w-0 px-3 py-5 bg-sky-50 border border-sky-200 rounded-xl">
          <H3 className=" ">RAZÓN SOCIAL</H3>
          <Texto className=" ">{user?.razonSocial}</Texto>
        </div>
        <div className="flex flex-col items-center justify-center text-center w-full min-w-0 px-3 py-5 bg-sky-50 border border-sky-200 rounded-xl">
          <H3 className=" ">NIT</H3>
          <Texto className=" ">{user?.nit}</Texto>
        </div>
        <div className="flex flex-col items-center justify-center text-center w-full min-w-0 px-3 py-5 bg-sky-50 border border-sky-200 rounded-xl">
          <H3 className=" "> ESTADO</H3>
          <Texto className=" ">{user?.status}</Texto>
        </div>
        <div className="flex flex-col items-center justify-center text-center w-full min-w-0 px-3 py-5 bg-sky-50 border border-sky-200 rounded-xl">
          <H3 className=" ">FECHA DE CREACIÓN</H3>
          <Texto className=" ">
            {convertData(user?.creationDate)}
          </Texto>
        </div>
        <div className="flex flex-col items-center justify-center text-center w-full min-w-0 px-3 py-5 bg-sky-50 border border-sky-200 rounded-xl">
          <H3 className=" ">CLIENTES HABILITADOS</H3>
          {data?.map((client, index) => {
            return (
              <Texto key={index} className="border-b-2">
                -{client?.name} {client?.fatherLastName}{" "}
                {client?.motherLastName}
              </Texto>
            );
          })}
        </div>
      </div>
    </div>
  );
};
